import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'components/elements';
import * as S from './styles';

const hhmmRegex = /([0-1]?[0-9]|2[0-3]):[0-5][0-9]-([0-1]?[0-9]|2[0-3]):[0-5][0-9]/g;

function TimesList({ listItems }) {
  function addBreakline(str, regex) {
    const matchedString = str?.replace(/\s/g, '').match(regex);
    if (matchedString) {
      return matchedString.join('\n').replace(/-/g, ' - ');
    }

    return str;
  }

  return (
    <S.TimesList data-testid="timelist">
      {listItems.map((listItem) => (
        <React.Fragment key={listItem.id}>
          <Text variant="label" colour="primary.700" lineHeight="2">
            {listItem.id.toUpperCase()}
          </Text>
          <Text variant="body2" colour="neutral.700" lineHeight="1.3" whiteSpace="pre-line">
            {addBreakline(listItem.value, hhmmRegex)}
          </Text>
        </React.Fragment>
      ))}
    </S.TimesList>
  );
}

TimesList.propTypes = {
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
};

export default TimesList;
